import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineBell } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { User } from "lucide-react";
import Image from "../Image";
import ApiService from "../../services/ApiService";
import { useUser } from "../../context/UserContext";

const Navbar = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { profileData, notifications, refreshProfile, refreshNotifications } = useUser();
  const languages = [
    { name: "English", code: "en", flag: "https://flagcdn.com/w320/us.png" },
    { name: "العربية", code: "ar", flag: "https://flagcdn.com/w320/sa.png" },
  ];

  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);
  };

  const onTalentSignOut = async () => {
    try {
      setShowDropdown(false);
      const response = await ApiService.request({
        method: "POST",
        url: "logout",
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        localStorage.clear();
        navigate("/");
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log("Error on Talent SignOut :- ", error);
    }
  };


  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };

    // Attach the listener to the whole document
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const [profileData, setProfileData] = useState(null);

  // useEffect(() => {
  //   fetchProfile();
  // }, []);

  // const fetchProfile = async () => {
  //   try {
  //     const response = await ApiService.request({
  //       method: "GET",
  //       url: `getProfile`,
  //     });
  //     const data = response.data;

  //     if (data.status) {
  //       setProfileData(data.data.talent);
  //     } else {
  //       toast.error(data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching profile:", error);
  //   }
  // };


  useEffect(() => {
    const currentLang = i18n.language;
    const direction = currentLang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", currentLang);
  }, [i18n.language]);
  return (
    <nav
      className="inter-font py-2 px-3 bg-transparent"
    // style={{ zIndex: 10000 }}
    >
      <b className="float-start mt-3 ms-5 d-flex align-items-center">
        Welcome, {profileData?.talent?.first_name+' '+profileData?.talent?.last_name || "Talent Name"} 
        <span className="badge bg-dark mx-3">Talent</span>
      </b>
      <ul className="inter-font list-unstyled d-flex justify-content-end align-items-center m-0">
        {/* Language Selector */}
        <li className="inter-font mx-3">
          <div
            onClick={() =>
              handleLanguageChange(i18n.language === "en" ? "ar" : "en")
            }
            // className={inter-font `lang-item ${
            //   i18n.language === lang.code ? "active-lang" : ""
            // }`}
            style={{
              cursor: "pointer",
              padding: "8px 15px",
              borderRadius: "10px",
              backgroundColor: "#6d5f27",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "15px",
            }}
          >
            {i18n.language === "en" ? "العربية" : "English"}
          </div>
          {/* <div className="inter-font d-flex border rounded-3 shadow-sm bg-white">
            {languages.map((lang) => (
              <div
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                style={{
                  cursor: "pointer",
                  padding: "8px 15px",
                  borderRadius: "10px",
                  backgroundColor:
                    i18n.language === lang.code ? "#181515" : "transparent",
                  color: i18n.language === lang.code ? "#fff" : "#000",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
              >
                {lang.name}
              </div>
            ))}
          </div> */}
        </li>

        {/* Home Link */}
        <li
          className="inter-font mx-2 inter-font"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/talent/dashboard")}
        >
          {t("home")}
        </li>

        {/* Jobs Link */}
        <li
          className="inter-font mx-2 inter-font"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/talent/projects")}
        >
          {t("c_s_tab6")}
        </li>

        {/* Notification Bell */}
        <li
          className="inter-font mx-3 position-relative"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() =>
            navigate("/talent/notification")
          }
          style={{ cursor: "pointer" }}
        >
          <HiOutlineBell
            style={{
              fontSize: "24px",
              color: isHovered ? "#CD496D" : "#333",
              transition: "color 0.3s",
            }}
          />
          {notifications.unread_count > 0 && 
          <span
            className="inter-font position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            style={{ fontSize: "10px", padding: "2px 6px" }}
          >
            {notifications.unread_count}
          </span>
}
        </li>

        {/* Profile Dropdown */}
        <li className="inter-font position-relative">


          <Image
            src={profileData?.talent?.picture}
            className="inter-font rounded-circle"
            alt="Profile"
            style={{
              width: "52px",
              height: "52px",
              cursor: "pointer",
              objectFit: "cover",
              border: "1px solid #d3d3d3",
            }}
            onClick={() => setShowDropdown(!showDropdown)}
          />

          {showDropdown && (
            <div
              ref={dropdownRef}

              className={`inter-font position-absolute  mt-2 bg-white shadow rounded-3 p-3 ${
      document.dir === 'rtl' ? 'start-0' : 'end-0'
    }`}
              style={{ width: "230px", zIndex: 2000 }}
            >
              <div className="inter-font d-flex align-items-center mb-3 gap-3">
                <Image
                  src={profileData?.talent?.picture}
                  className="inter-font rounded-circle"
                  style={{ width: "39px", height: "39px", objectFit: "cover", border: "1px solid #d3d3d3",cursor:"pointer" }}
                  alt="Profile"
                />

                <div className="inter-font ">
                  <div className="inter-font fw-bold">{profileData?.talent?.first_name} {profileData?.talent?.last_name}</div>
                  <div className="inter-font text-muted" style={{ fontSize: "13px" }}>
                    {profileData.talent?.skill_id
                      ? i18n.language === "ar"
                        ? profileData.talent.skill_id.title_ar ||
                          profileData.talent.skill_id.title
                        : profileData.talent.skill_id.title
                      : ""}
                  </div>
                </div>
              </div>

              <button
                className="inter-font btn btn-sm w-100 text-white mb-3"
                style={{ backgroundColor: "rgb(231, 142, 123)" }}
                onClick={() => navigate("/talent/profile")}
              >
                {t("c_s_tab10")}
              </button>

              {/* <div className="inter-font mb-2">
                <div className="inter-font fw-bold mb-1">Account</div>
                <div
                  className="inter-font text-muted inter-font"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  onClick={() => navigate("/talent/settings")}
                >
                  Settings & Privacy
                </div>
              </div> */}

              <div
                className="inter-font text-danger mt-2"
                style={{ fontSize: "14px", cursor: "pointer" }}
                onClick={onTalentSignOut}
              >
                {t("new_text_20")}
              </div>
            </div>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
